import { AvvirEvent } from "type_aliases";
import { ApiPipeline } from "avvir";

export type PipelinesForFloorLoadedEvent = AvvirEvent<typeof PIPELINES_FOR_FLOOR_LOADED, {
  projectId: string
  floorId: string
  pipelines: ApiPipeline[]
}>

const pipelinesForFloorLoaded = (projectId: string, floorId: string, pipelines: ApiPipeline[]): PipelinesForFloorLoadedEvent => ({
  type: PIPELINES_FOR_FLOOR_LOADED,
  payload: {
    projectId,
    floorId,
    pipelines
  }
});

export const PIPELINES_FOR_FLOOR_LOADED = "floor_pipelines_loaded";

export default pipelinesForFloorLoaded;
